import Cookies from 'js-cookie';

let popupTimerActive = false;

function addEvent(obj, evt, fn) {
    if (obj.addEventListener) {
        obj.addEventListener(evt, fn, false);
    } else if (obj.attachEvent) {
        obj.attachEvent("on" + evt, fn);
    }
}

function CheckForSystemPopups() {
    document.querySelectorAll('.system-popup').forEach(systemPopup => {

        const popupExpired = systemPopup.dataset.popupExpired === 'true';
        if (popupExpired) return;

        const popupTimer = parseInt(systemPopup.dataset.popupTimeout);
        const popupTrigger = systemPopup.dataset.popupTrigger;

        if (popupTrigger === "timer") {
            if (popupTimer >= 0) {
                if (!popupTimerActive) {
                    popupTimerActive = true;
                    setTimeout(() => {
                        systemPopup.classList.add('active');
                        document.querySelector('.system-popup-overlay')?.classList.add('active');
                    }, popupTimer * 1000);
                } else {
                    setTimeout(CheckForSystemPopups, 10000);
                }
            }
        } else if (popupTrigger === "onexit") {
            setTimeout(() => {
                addEvent(document, 'mouseout', function (evt) {
                    if (!evt.toElement && !evt.relatedTarget) {
                        if (systemPopup.dataset.popupExpired !== 'true') {
                            systemPopup.classList.add('active');
                            document.querySelector('.system-popup-overlay')?.classList.add('active');
                        }
                    }
                });
            }, popupTimer);
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    if (typeof Cookies !== 'undefined') {
        document.querySelectorAll('.system-popup').forEach(systemPopup => {

            const popupKey = systemPopup.dataset.popupKey;
            const popupCookieExpires = parseInt(systemPopup.dataset.popupCookieExpires);
            const forcePopupCookieExpired = systemPopup.dataset.forcePopupCookieExpired === 'true';

            // Expire if cookie already exists
            if (Cookies.get('popup_' + popupKey + '_closed') === 'yes') {
                systemPopup.dataset.popupExpired = 'true';
            } else {
                systemPopup.dataset.popupExpired = 'false';
            }

            if (forcePopupCookieExpired) {
                Cookies.set('popup_' + popupKey + '_closed', 'yes', { expires: popupCookieExpires, path: '/' });
                systemPopup.classList.add('active');
            }

            // Close button
            systemPopup.querySelectorAll('.popup-close').forEach(closeBtn => {
                closeBtn.addEventListener('click', () => {
                    systemPopup.classList.remove('active');
                    document.querySelector('.system-popup-overlay')?.classList.remove('active');

                    Cookies.set('popup_' + popupKey + '_closed', 'yes', { expires: popupCookieExpires, path: '/' });
                    systemPopup.dataset.popupExpired = 'true';
                    popupTimerActive = false;

                    CheckForSystemPopups();
                });
            });

            // Link or image click
            systemPopup.querySelectorAll('a.close-popup').forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    const href = link.href;

                    systemPopup.classList.remove('active');
                    document.querySelector('.system-popup-overlay')?.classList.remove('active');

                    Cookies.set('popup_' + popupKey + '_closed', 'yes', { expires: popupCookieExpires, path: '/' });
                    systemPopup.dataset.popupExpired = 'true';
                    popupTimerActive = false;

                    CheckForSystemPopups();

                    window.location.href = href;
                });
            });
        });

        CheckForSystemPopups();
    }

    // Close popup if overlay clicked
    document.querySelector('.system-popup-overlay')?.addEventListener('click', () => {
        document.querySelectorAll('.system-popup.active').forEach(systemPopup => {
            const popupKey = systemPopup.dataset.popupKey;
            const popupCookieExpires = parseInt(systemPopup.dataset.popupCookieExpires);

            Cookies.set('popup_' + popupKey + '_closed', 'yes', { expires: popupCookieExpires, path: '/' });
            systemPopup.dataset.popupExpired = 'true';

            systemPopup.classList.remove('active');
        });

        document.querySelector('.system-popup-overlay')?.classList.remove('active');
    });
});